export default __webpack_public_path__ + "static/media/negative_logo.29805c2a.png";